<template>
  <div id="app">
    <div v-if="$root.loadApp">
      <v-loading v-if="$root.showLoading" :texto="$root.textLoading"></v-loading>
      <header-component></header-component>

      <transition name="slide-fade" mode="out-in">
        <router-view/>
      </transition>
      <footer-component></footer-component>
    </div>
    <div v-else>
      <v-loading v-if="$root.showLoading" :texto="$root.textLoading"></v-loading>
    </div>
    <div id="form-transparent" style="display: none;"></div>
  </div>
</template>

<script>
  import HeaderComponent from './components/includes/Header.vue'
  import FooterComponent from './components/includes/Footer.vue'
  export default {
    name: 'App',
    components: {
      HeaderComponent,
      FooterComponent,
    },
    computed: {
      token: function () {
        return this.$route.query.token
      },
      refresh_token: function () {
        return this.$route.query.refresh_token
      },
    },
    methods: {
      redirect() {
        let params = this.$root.getQueryParams()
        if(params.hasOwnProperty('return') && params.return != ""){
          location.href = decodeURIComponent(params.return)
        }
        else{
          this.$root.redirectAuthenticated(false)
        }
      },
    },
    beforeCreate() {
        console.info('Carregando App...')
        $(() => {
          $.modal.defaults.fadeDuration = 500
          $.modal.defaults.escapeClose = false
          $.modal.defaults.clickClose = false
          $.modal.defaults.showClose = false
        })
    },
    created() {
      if(this.token){
        localStorage.setItem('token', this.token)
        localStorage.setItem('refresh_token', this.refresh_token)
      }
    }
  }
</script>

<style lang="css">
  @import "assets/css/app.css";

  a{
    cursor: pointer;
  }

  .slide-fade-slow-enter-active {
    transition: all 1s ease;
  }
  .slide-fade-slow-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-slow-enter, .slide-fade-slow-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .1s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/App.vue